export default __webpack_public_path__ + "static/media/1.2023c959.png";